var Scripts = {

    _items: [],

    load: function (scriptFn) {
        this._items.push(scriptFn);
    },

    init: function () {
        var self = this;

        $(self._items).each(function (i, item) {
            item();
        });
    }

};

function SavedDataState () {

    this.savedData = {};
    var self = this;

    this.hasChanged = function(obj)
    {
        var compareObj = {};
        $.each(obj, function (objKey, objValue) {
            if (typeof objValue === 'number' || typeof objValue === 'string' || typeof objValue === 'boolean')
                compareObj[objKey] = objValue;
        });

        if ((!self.savedData && compareObj) ||
            (self.savedData && !compareObj) ||
            (Object.keys(self.savedData).length != Object.keys(compareObj).length))
            return true;

        var changed = false;
        $.each(compareObj, function (objKey, objValue) {
            $.each(self.savedData, function (k, v) {
                if (objKey === k && objValue != v)
                    changed = true;
            });
        });
        
        return changed;
    };

    this.setData = function (obj) {
        self.savedData = {};

        if (obj) {
            $.each(obj, function (k, v) {
                if (typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean')
                    self.savedData[k] = v;
            });
        }
    };

}